/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_EditInputs */

const en_jobs_edit = /** @type {(inputs: Jobs_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const de_jobs_edit = /** @type {(inputs: Jobs_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten`)
};

const fr_jobs_edit = /** @type {(inputs: Jobs_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier`)
};

const es_jobs_edit = /** @type {(inputs: Jobs_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const it_jobs_edit = /** @type {(inputs: Jobs_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica`)
};

const nl_jobs_edit = /** @type {(inputs: Jobs_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerken`)
};

const pl_jobs_edit = /** @type {(inputs: Jobs_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edytuj`)
};

const fi_jobs_edit = /** @type {(inputs: Jobs_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muokkaa`)
};

const da_jobs_edit = /** @type {(inputs: Jobs_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rediger`)
};

const sv_jobs_edit = /** @type {(inputs: Jobs_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redigera`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Jobs_EditInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_edit = /** @type {((inputs?: Jobs_EditInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_EditInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_edit(inputs)
	if (locale === "fr") return fr_jobs_edit(inputs)
	if (locale === "es") return es_jobs_edit(inputs)
	if (locale === "it") return it_jobs_edit(inputs)
	if (locale === "nl") return nl_jobs_edit(inputs)
	if (locale === "pl") return pl_jobs_edit(inputs)
	if (locale === "fi") return fi_jobs_edit(inputs)
	if (locale === "da") return da_jobs_edit(inputs)
	if (locale === "sv") return sv_jobs_edit(inputs)
	return en_jobs_edit(inputs)
});